import React, { useState, FC, useEffect, useRef, Dispatch } from "react";
import { RouteComponentProps, useLocation, } from "react-router-dom";
import "./home.scss";
import { NavFileContainer } from "../../SideDrawer/sidedrawer";
import { NavObjectType, NavObjectWinState, ScreenActions, TabNames, lddGlobalSessionInfo, PopupPageId, purfileController } from "../navigationTypes";
import NavFileContainerRightSide from "../../fileToolbar/fileToolbarSideBar";
import { getDataReader, RPWDataReader } from '../../livedataFuncs';
import MainIFrame, { navigateNewPage } from "./compat";
import { useDispatch, } from 'react-redux';
import { setInternetDown, setShowRenewSession, setSessionState, setSessionInfo, lddStateObject, setActivityCenter, setActivityCenterAddNew, setActivityCenterDelete, setClientPortalPage, setIndicators, ReducerEnum, setPreference, setProfilePreferences, setNavigation, clearDisplayToastMessage, setUserPreferences } from '../../redux/reducer'
import { fileTabVal } from "../../SideDrawer/sideTypes";
import { activityCenterObject } from "../../fileToolbar/ActivityCenter/activityCenterTypes";
import { useAppSelector } from "../../redux/hooks";
import { formatAMPMString } from "../../fileToolbar/fileToolbarFuncs";
import { closeAll, getCurrentContentWindow, runInnerFunction, CloseInframeComponent, updateHost } from "../../compatManager";
import { Loading } from "../Loading";
import { store } from "../../redux/store";
import { NavigationContext } from "../../Context/NavigationContext";
import { AnyAction } from "redux";
import { ThirdPartyDispatch } from "../ThirdPartyList/ThirdPartyFuncs";
import { ScreenController, getSubTabName } from "../../screenController";
import { ToastMessaging, displayToastMsg } from "../toastMessages/toastmessages"
import ReactFrame from "../reactFrame/reactFrame";
import RenewSessionPopup from "../RenewSessionPopup";
import PaymentReminderPopup from "../PaymentReminderPopup";
import { ClientPortalModalDispatch, ClientPortalPageDispatch } from "../clientportal/App";
import HOMECONST from "./const";
import MainPage from "./MainPage";
import BGTask, { FileLock } from "./BGTask";
import { ActivityCenterContext } from "../../Context/ActivityCenter";
import FileListPage from "./FileListPage";
import InFile from "./InFile";
import { RightDrawerOption } from "../../fileToolbar/fileToolbarTypes";
import handleGenSessionInfo, { handleFirmUpdate } from "./sessionInfoHandler";
import Preference from "../../lib/preference";
import UserPreferencesApi from "../../lib/userPreferences";
import { Modal, Button } from "react-bootstrap";
import GetReactModalFrame from "../reactFrame/reactModalFrame";
import MarketingCheck from "../marketingCheck/marketingCheck";
import { LenderCentre } from "../MortgageAnalyzer/LenderCentre";
import UserContactListModal from "../clientportal/components/UserContactListModal";
import TopBar from "../topbars/TopBar";
import UpdatePasswordModal from '../UpdatePassword/UpdatePasswordModal';
import SolunoExport from '../Soluno/SolunoExport';
import ChequeInit from "../chequePrinting/ChequeInit";
import EditChequeDetails from "../Settings/ChequePrint/editChequeDetails";
import EditFileNumberWarning from "../FileNumberWarning/fileNumberModal";
import { APSNewFile } from "../fileList/APSNewFile";
type SomeComponentProps = RouteComponentProps;

export const RightSideContext = React.createContext(
    {
        rightSideBoolean: false,
        rightSideShow: '',
        account: ''
    }
);
const FileCheckList: any = {
    BGTaskCheck: false,
    OneTimeCheck: false,
    LockStatusInterval: null
};

const Home: FC<SomeComponentProps> = ({ history }) => {
    const location = useLocation();
    const paramsJSON = new URLSearchParams(location.search).get("params");
    const [page, setPage] = useState<NavObjectType>(paramsJSON ? { ...JSON.parse(paramsJSON) } : {
        component: "filelist",
    });
    const search = window.location.search;
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const URLsid = new URLSearchParams(search).get('SessionID');
    const dispatch = useDispatch();
    const SessionRenewInterval = useRef(null);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const [drawerState, setDrawerState] = useState<fileTabVal>(fileTabVal.SUMMARY);
    const [leftDrawerSelection, setLeftDrawerSelection] = useState<Record<fileTabVal, NavObjectType>>(structuredClone(HOMECONST.defaultLeftDrawerState));
    const pinnedRightSideTab = useAppSelector((g: lddStateObject) => g.Preference["PinRightSideTab"]);
    const defaultFileOpeningScreen = useAppSelector((g: lddStateObject) => g.UserPreferences.defaultFileOpeningScreen);
    const defaultFileOpeningScreenRef = useRef<"Summary" | "Details">(defaultFileOpeningScreen);
    const DEFAUL_RIGHTTDRAWER: RightDrawerOption = "KeyDates";
    const [rightDrawer, setRightDrawer] = useState<RightDrawerOption>(pinnedRightSideTab !== "toggle" ? pinnedRightSideTab : DEFAUL_RIGHTTDRAWER);
    const [rightBarVisible, setRightBarVisible] = useState<boolean>(window.innerWidth > 1660);
    const activityCenterObjectArray: activityCenterObject[] = useAppSelector((g: lddStateObject) => g.ActivityCenter);
    const Indicators = useAppSelector((g: lddStateObject) => g.Indicators);
    const DisplayToastMessage = useAppSelector((g: lddStateObject) => g.DisplayToastMessage);
    const [changeNoteDropdown, setChangeNoteDropdown] = useState<boolean>(false);
    const [fileLockIndicator, setFileLockIndicator] = useState<FileLock>(null);
    const [showModal, setShowModal] = useState("");
    const fileLockIndicatorRef = useRef<FileLock | null>(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const updateFileLockIndicator = (updatedFileLockIndicator: FileLock | null) => {
        setFileLockIndicator(updatedFileLockIndicator);
        fileLockIndicatorRef.current = updatedFileLockIndicator;
    };

    function lddActivityCentreListener(event) {
        const detail = event?.detail;
        const param = detail?.param
        switch (detail.event) {
            case "add":
                lddActivityCenterAdd(param.msg, param.onclick, param.type, param.lddActivityCenterTracker, param.clearWhenOut, param.fileNumber);
                break;
            case "delete":
                lddActivityCenterDelete(param.counter);
                break;
            default:
                console.log(`Incorrect Activity Centre event: [${event.detail.event}]`);
                break;
        }
    }
    async function RenewSession() {
        try {
            let res = await fetch(`RenewSessionID.asp?SessionID=${URLsid}`);
            let response = await res.text();
            if (response.indexOf("<Error>") !== -1) {  // already bad
                dispatch(setShowRenewSession(true));
            }
            else {
                dispatch(setShowRenewSession(false));
                dispatch(setInternetDown(false));
            }
        } catch (e) {
            dispatch(setInternetDown(true));
        }
    }

    function closeRightDrawer() {
        // if inside a file and a tab is pinned
        if (navigationInFile(page) && pinnedRightSideTab !== "toggle") {
            setRightDrawer(pinnedRightSideTab);
        }
        setRightBarVisible(false);
    }

    function updateRightBar() {
        if (navigationInFile(page) && window.innerWidth > 1660) {
            // if a tab a pined
            showRightBar()
            return;
        }
        closeRightDrawer();
    }

    function updateWindowDimensions() {
        // we don't want to update right bar with resize right now
        // updateRightBar()
        return;
    }

    function showRightBar(){
        if (pinnedRightSideTab !== "toggle" && pinnedRightSideTab === rightDrawer) {
            setRightDrawer(pinnedRightSideTab);
        }
        setRightBarVisible(true);
    }

    const handleRightDrawerToggle = (option: RightDrawerOption): void => {
        if (option === 'toggle') {
            if (rightBarVisible) {
                closeRightDrawer();
            } else {
                // if in purfile &  a tab a pined
                if (navigationInFile(page) && pinnedRightSideTab !== "toggle") {
                    setRightDrawer(pinnedRightSideTab);
                } else if (!navigationInFile(page)) {
                    // outside of file
                    setRightDrawer("Activity");
                }
                setRightBarVisible(true);
            }
        } else if (rightDrawer === option && rightBarVisible) {
            closeRightDrawer();
        } else {
            setRightDrawer(option);
            setRightBarVisible(true);
        }
    }
    useEffect(() => {
        if (rightBarVisible) {
            // opening right bar
            // reset indicator & ActivityCenter Unread count
            if (rightDrawer === "Activity") {
                dispatch(setIndicators("Activity", false));
                dispatch({ type: ReducerEnum.SET_RESET_ACTIVITYCENTERUNREAD })
            }
            else if(pinnedRightSideTab === 'toggle' && rightDrawer === 'toggle'){
                setRightDrawer('KeyDates');
            }
        }
    }, [rightBarVisible, rightDrawer])

    const normalizeDefaultFileOpeningScreen = (value?: string | null): "Summary" | "Details" => {
        if (value === "Summary" || value === "Details") {
            return value;
        }
        return "Summary";
    };

    useEffect(() => {
        if (!SESSION_INFO?.sid || !SESSION_INFO?.appProvinceShort || !SESSION_INFO?.firm?.id) {
            return;
        }
        const rwapi = `/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SESSION_INFO.appProvinceShort}/${SESSION_INFO.firm.id}`;
        fetch(`${rwapi}/userpreferences?SessionID=${SESSION_INFO.sid}`)
            .then((response) => response.json())
            .then((payload) => {
                const screen = normalizeDefaultFileOpeningScreen(payload?.result?.defaultFileOpeningScreen);
                dispatch(setUserPreferences({ defaultFileOpeningScreen: screen }));
            })
            .catch(() => {
                dispatch(setUserPreferences({ defaultFileOpeningScreen: "Summary" }));
            });
    }, [SESSION_INFO?.sid, SESSION_INFO?.appProvinceShort, SESSION_INFO?.firm?.id])

    useEffect(() => {
        defaultFileOpeningScreenRef.current = defaultFileOpeningScreen;
    }, [defaultFileOpeningScreen]);

    const getDrawerStateFromTabName = (
        tabName: TabNames | PopupPageId | undefined,
    ): fileTabVal => {
        const defaultDrawerState = (defaultFileOpeningScreenRef.current === "Details") ? fileTabVal.DETAILS : fileTabVal.SUMMARY;
        let drawerState = defaultDrawerState;
        
        if (!(tabName > "")) {
            drawerState = defaultDrawerState;
        } else {
            switch (tabName) {
                case "Summary":
                    drawerState = fileTabVal.SUMMARY;
                    break;
                case "NewHome":
                    drawerState = fileTabVal.NEWHOME;
                    break;
                case "Documents":
                    drawerState = fileTabVal.DOCUMENTS;
                    break;
                case "Client Portal":
                    drawerState = fileTabVal.CLIENTPORTAL
                    break;
                default:
                    drawerState = fileTabVal.DETAILS;
            }
        }
        
        return drawerState;
    }

    const getNavParam = (tab: fileTabVal) => {
        switch (tab) {
            case fileTabVal.SUMMARY:
                return {controller: {tabName: "Summary"}, reactFrame: "Summary"};
            default:
                return {controller: {tabName: "Basic", tabNumber: 0}, label: "Basic"};
        }
    }

    const handleLeftDrawerClick = (newFileTabVal: fileTabVal): void => {
        if (drawerState !== newFileTabVal) {
            setDrawerState(newFileTabVal);
            if (leftDrawerSelection[newFileTabVal] && page.params.formasp === "purfileedit") {
                const navigation = leftDrawerSelection[newFileTabVal];
                navigation.params.id = purfileNavStripPopups(page).params.id;
                if (navigation?.controller?.refresh) {
                    delete navigation.controller.refresh;
                }
                changeFrame(navigation);
            }
        }
    }

    // block window unload if page is dirty
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (Indicators.IsPageDirty) {
                const msg = "You have unsaved changes. Are you sure you want to leave this page without saving?";
                event.returnValue = msg;
                return msg;
            }
        }

        const handleUnload = () => {
            if (Indicators.IsPageDirty) {
                dispatch(setIndicators("IsPageDirty", false));
            }
        }

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleUnload);
        }
    }, [Indicators.IsPageDirty, dispatch]);

    const checkPurfileEdit = (checkNav: NavObjectType) => { return checkNav.component === "main" && checkNav.params?.formasp === "purfileedit" };
    function changeFrame(navObj: NavObjectType): void {
        // Don't update main state if just opening popup window
        if (navObj.popup || navObj.isModal) {
            if (navObj.url) {
                if (typeof navObj.url === "string") {
                    let numberURL = parseInt(navObj.url);
                    if (numberURL === -1 || numberURL === 1) {
                        navObj.url = numberURL;
                    }
                }
                const windowState: NavObjectWinState = {
                    dialogArguments: {
                        liveformPopupDataNode: livedataRootContainer.dataRoot,
                        datalockobj: {},
                    }
                };
                var winState: NavObjectWinState = (navObj.windowState) ? navObj.windowState : windowState;
                let ret = navigateNewPage(navObj, SESSION_INFO.sid, winState);
                if (navObj.callback) {
                    ret.then((val) => {
                        const callbackRet = navObj.callback(val);
                        if (callbackRet && navObj.redirect) {
                            changeFrame(callbackRet)
                        }
                    });
                }
            } else if (navObj.reactModalFrame) {
                setShowModal(navObj.reactModalFrame);
            }
        } else {
            checkNavigationSecondaryEffects(navObj, dispatch, SESSION_INFO);

            if (navObj.params?.clientPortalModalType !== '' && navObj.params?.clientPortalModalType !== undefined && navObj.params?.clientPortalModalType !== null) {
                ClientPortalModalDispatch(dispatch, navObj.params?.clientPortalModalType)
                return;
            }
            if (navObj.params?.clientPortalState !== '' && navObj.params?.clientPortalState !== undefined && navObj.params?.clientPortalState !== null) {
                ClientPortalPageDispatch(dispatch, navObj.params?.clientPortalState)
                return;
            }
            if (navObj.params?.connectTab !== null && navObj.params?.connectTab !== undefined && navObj.params?.connectTab === 'true') {
                dispatch(setClientPortalPage('ClientIntake'));
            }

            if (Indicators.IsPageDirty) {
                const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to leave this page without saving?");
                if (confirmLeave) {
                    dispatch(setIndicators("IsPageDirty", false));
                } else {
                    return;
                }
            }

            if (navObj.component === "main" && !navObj.url) {
                return;
            }
            const navPurfileToPurfile = checkPurfileEdit(page) && checkPurfileEdit(navObj);
            const normalizeId = (value: any): string | undefined => {
                if (value === undefined || value === null) {
                    return undefined;
                }
                const trimmed = String(value).trim();
                return trimmed.length > 0 ? trimmed : undefined;
            };
            const currentAppId = checkPurfileEdit(page) ? livedataRootContainer?.dataRoot?.getAttribute("AppID") : undefined;
            let pageId = normalizeId(page.params?.id ?? currentAppId);
            const navId = normalizeId(navObj.params?.id);
            if (!pageId && navId && navPurfileToPurfile) {
                pageId = navId;
            }
            const sameIDPurfile = (pageId !== undefined && navId !== undefined)
                ? (pageId === navId || (Number.isFinite(Number(pageId)) && Number.isFinite(Number(navId)) && Number(pageId) === Number(navId)))
                : pageId === navId;

            // init is for if we refresh page or otherwise go into the page
            if (!navPurfileToPurfile || !sameIDPurfile) {
                navObj = { ...navObj, init: true }
            }
            if (!navPurfileToPurfile) {
                // Close all frame tabs when moving to new component
                if (!closeAll()) {
                    return;
                }
                setChangeNoteDropdown(true);
            }

            // checking navigating from/to File
            if (checkPurfileEdit(page) && !checkPurfileEdit(navObj)) {
                // when get out of a file
                gettingOutOfFile();
            } else if (checkPurfileEdit(navObj) && (!sameIDPurfile || navObj.controller?.refresh)) {
                // if entering a new file reset left side to default
                const storageObjGet = window.localStorage;
                const UserDocPreference = storageObjGet.getItem("lddDocumentsDefault");
                const NewDefaultLeftDrawerState = structuredClone(HOMECONST.defaultLeftDrawerState);
                if (UserDocPreference > "") {
                    const newDocController: { label: string, controller: purfileController } = JSON.parse(UserDocPreference);
                    if (newDocController?.controller?.tabName > "") {
                        NewDefaultLeftDrawerState[fileTabVal.DOCUMENTS].controller = newDocController.controller;
                        NewDefaultLeftDrawerState[fileTabVal.DOCUMENTS].label = newDocController.label;
                    }
                }
                setLeftDrawerSelection(NewDefaultLeftDrawerState);
                // set the controller if it doesnt exist: creating new file
                // for new file opens, use preference-based default; if an explicit tab is requested, honor it
                const hasExplicitTab = navObj.controller?.tabName > "";
                if(!hasExplicitTab){
                    let params = getNavParam(defaultFileOpeningScreenRef.current === "Details" ? fileTabVal.DETAILS : fileTabVal.SUMMARY);
                    navObj = {...navObj, controller: params.controller as purfileController, label: params.label, reactFrame: params.reactFrame};
                }

                const newDrawerState = getDrawerStateFromTabName(navObj.controller?.tabName)
                setDrawerState(newDrawerState);
                
                // reset FileCheckList
                Object.keys(FileCheckList).forEach(k => FileCheckList[k] = false);
                // reset right sidebar
                setRightDrawer(pinnedRightSideTab !== "toggle" ? pinnedRightSideTab : DEFAUL_RIGHTTDRAWER);
                if(window.innerWidth > 1660){
                    showRightBar();
                } else {
                    setRightBarVisible(false);
                }
            }
            // nav out of summary screen
            if(drawerState === fileTabVal.SUMMARY){
                switch(navObj.controller?.tabName){
                    case "Summary":
                        break;
                    case "Client Portal":
                    case "ClientConnect":
                        setDrawerState(fileTabVal.CLIENTPORTAL);
                        break;
                    case "NewHome":
                        setDrawerState(fileTabVal.NEWHOME);
                        break;
                    case "Documents":
                        setDrawerState(fileTabVal.DOCUMENTS);
                        break;
                    default:
                        setDrawerState(fileTabVal.DETAILS);
                }
            }
            let compatFile = "compatshell";
            if (process.env.REACT_APP_BUILD_URL && process.env.REACT_APP_BUILD_URL !== "") {
                compatFile = compatFile + "_" + process.env.REACT_APP_BUILD_URL;
            }
            history.push(compatFile + ".html?SessionID=" + URLsid + "&params=" + encodeURIComponent(JSON.stringify(navObj)));
            // update page
            setPage({ ...navObj });
            dispatch(setNavigation(navObj));

            // close modal
            setShowModal("");
        }
    }

    function gettingOutOfFile() {
        lddActivityCenterClearWhenOut();
        setRightBarVisible(false);
        dispatch(setIndicators("MyDriveHasNewDoc", false));
        setFileLockIndicator(null);
        clearInterval(FileCheckList.LockStatusInterval);
        FileCheckList.LockStatusInterval = null;
    }

    function GetReactFrame() {
        if (page.reactFrame !== '' && page.reactFrame !== undefined && page.reactFrame !== null) {
            return <ReactFrame reactFrame={page.reactFrame} />
        } else {
            return <></>;
        }
    }

    function GetMainComponent(): React.ReactElement {
        if (SESSION_INFO) {
            let component;
            switch (page.component) {
                case 'main':
                    return <></>;
                case 'filelist':
                    component = <FileListPage />
                    break;
                case 'SolunoExport':
                    component = <SolunoExport />
                    break;
                default:
                    break;
            }
            return component;
        } else {
            return <Loading />;
        }
    }

    const iframeProp = <MainIFrame page={page} />

    function lddActivityCenterAdd(
        msg: string,
        onclick: activityCenterObject['browserLink'],
        type: activityCenterObject['type'],
        lddActivityCenterTracker: number | string,  // number for msg from webapp, msg from ReachShell has to use string tracker
        clearWhenOut?: boolean,
        fileNumber?: string,
    ) {
        if (!(rightBarVisible && rightDrawer === "Activity")) {
            displayToastMsg({ id: null, msg: msg, type: type }, onclick)
        }

        let currentDate = new Date();
        let dateStr = currentDate.toDateString().split(" ");
        let timeStr = currentDate.toTimeString();
        timeStr = formatAMPMString(timeStr);

        const newMessage: activityCenterObject = {
            index: lddActivityCenterTracker,
            message: msg,
            browserLink: onclick,
            type: type,
            fileNumber: fileNumber ?? null,
            dateCreated: timeStr + ' ' + dateStr[1] + ' ' + dateStr[2] + ' ',
            clearWhenOut: clearWhenOut ? clearWhenOut : false,
        };

        dispatch(setActivityCenterAddNew(newMessage));
        return lddActivityCenterTracker;
    }

    function lddActivityCenterClearWhenOut() {
        const newActivityCenterObjectArray = activityCenterObjectArray.filter(msg => msg.clearWhenOut === false);
        dispatch(setActivityCenter(newActivityCenterObjectArray));
    }

    function lddActivityCenterDelete(counter: number | string) {
        dispatch(setActivityCenterDelete(counter));
    }

    //  - Load SessionInfo (even not async)
    useEffect(() => {
        async function fetchData() {
            const res = await fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/cur/uv/get/curUser?SessionID=${URLsid}`);
            if (res.status === 403) {
                window.location.href = "loginldd.html?ErrorMsg=Session timeout."
            }
            const resSession = await res.json();
            const { UserID, StationID } = resSession.result;
            const appcodePromise = fetch(`getGlobal.asp`);
            const appcodeRes = await appcodePromise;
            const responsesJSON = await Promise.all([
                fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/user?id=${StationID}&SessionID=${URLsid}`),
                fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/firm?SessionID=${URLsid}`),
            ]);
            const genSessionInfoResponse = await handleGenSessionInfo(resSession, appcodeRes, responsesJSON, URLsid);
            const SessionInfo: lddGlobalSessionInfo = await handleFirmUpdate(genSessionInfoResponse);
            dispatch(setSessionInfo(SessionInfo));

            // get & cache shell preference in store
            Preference.get(SessionInfo).then((preference) => {
                Object.keys(preference).forEach(key => {
                    dispatch(setPreference(key as keyof lddStateObject["Preference"], preference[key]));
                    if (key === "PinRightSideTab") {
                        setRightDrawer(preference[key]);
                    }
                })
            });

            // get & cache user preferences in store
            UserPreferencesApi.get(SessionInfo).then((userPrefs) => {
                if (userPrefs && Object.keys(userPrefs).length) {
                    dispatch(setUserPreferences(userPrefs));
                }
            });

            RenewSession();  // call first time
            SessionRenewInterval.current = setInterval(function () {
                RenewSession()
            }, 3 * 60 * 1000);
        }


        // Load SID into state
        if (SESSION_INFO?.sid !== URLsid) {
            dispatch(setSessionState(URLsid));
        }
        // load the rest SESSION_INFO
        fetchData();
        return () => {
            if (SessionRenewInterval.current) {
                clearInterval(SessionRenewInterval.current)
            }
        }
    }, [])

    useEffect(() => {
        if (document.getElementById("lddIFrame")) {
            updateHost(document.getElementById("lddIFrame"));
        }
    }, [SESSION_INFO])

    useEffect(() => {
        const checkPurfileEdit = (checkNav: NavObjectType) => { return checkNav.component === "main" && checkNav.params?.formasp === "purfileedit" };
        let navReturn = new Promise((resolve, reject) => {
            try{
                let passingObjects = {
                    'ShellInitFunc': (window) => { resolve(window) }
                }
                // init is for if we refresh page or otherwise go into the page
                if (!page.init && !page.controller?.refresh && checkPurfileEdit(page)) {
                    let currentWindow = getCurrentContentWindow();
                    if (currentWindow?.window?.location?.href?.indexOf("purfileedit") !== -1) {
                        return resolve(currentWindow);
                    }
                }
                navigateNewPage(page, URLsid, passingObjects);
            } catch (err) {
                reject(err);
            }
            
        })
        if (checkPurfileEdit(page)) {
            if (page.controller?.refresh && !(page.controller?.tabName > "")) {
                const defaultDrawerState = (defaultFileOpeningScreenRef.current === "Details") ? fileTabVal.DETAILS : fileTabVal.SUMMARY;
                setDrawerState(defaultDrawerState);
            }
            navReturn?.then((newWindow: any) => {
                console.log("top loaded")
                if (checkPurfileEdit(page) && newWindow) {
                    const controller = new ScreenController(newWindow);
                    let tabName, tabNumber;
                    if (!page.controller) {
                        // If no controller, set basic page
                        tabName = 'Basic';
                        tabNumber = 0;
                    } else {
                        tabName = page.controller.tabName
                        tabNumber = page.controller.tabNumber
                    }
                    try {
                        controller.setTabFromName(tabName, tabNumber);
                        let newSubState = leftDrawerSelection;
                        if (newSubState[drawerState].controller !== page.controller || newSubState[drawerState].label !== page.label) {
                            newSubState[drawerState].controller = {...page.controller};
                            newSubState[drawerState].label = page.label;
                            newSubState[drawerState].reactFrame = page.reactFrame;
                            if(newSubState[drawerState].controller.autoClick){
                                delete newSubState[drawerState].controller.autoClick;
                            }
                            if(newSubState[drawerState].controller.autoClickClassName){
                                delete newSubState[drawerState].controller.autoClickClassName;
                            }
                            if(newSubState[drawerState].controller.autoClickClassNamePosition){
                                delete newSubState[drawerState].controller.autoClickClassNamePosition;
                            }
                            setLeftDrawerSelection(newSubState);
                        }
                    } catch (e) {
                        console.log("Cannot currently setTab, ensure file is loaded")
                    }
                    if (page.scrollToId) {
                        const element = newWindow.document.getElementById(page.scrollToId);
                        if (element) {
                            element.scrollIntoView();
                        }
                    }
                }
            })
        } else { //not in a file
            if (window.top.document.title !== "Realti") {
                window.top.document.title = 'Realti';
            }
        }

        window.addEventListener("LDDChangeFrame", changeFrameEvent);
        return () => {
            window.removeEventListener("LDDChangeFrame", changeFrameEvent);
        }
    }, [location, SESSION_INFO?.appCode, URLsid])
    const changeFrameEvent = (event) => changeFrame((event as any).detail);
    useEffect(() => {
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);
        return () => { window.removeEventListener('resize', updateWindowDimensions) }
    }, [page])  // needs to re-addEventListener when state changes

    useEffect(() => {
        // Setup iframe with correct navigation
        if (page.url) {
            if (typeof page.url === "string") {
                let numberURL = parseInt(page.url);
                if (numberURL === -1 || numberURL === 1) {
                    page.url = numberURL;
                }
            }
            navigateNewPage(page, URLsid);
        }
    }, []) // only load once

    useEffect(() => {
        updateRightBar();
        window.addEventListener("LDDActivityCentre", lddActivityCentreListener);
        return () => {
            window.removeEventListener("LDDActivityCentre", lddActivityCentreListener);
        }
    }, [])

    useEffect(() => {
        // retaining the code to determine if any feature depends on this state update
        // async function fetchProfileData() {
        //     const res = await fetch(`getprofile.asp?pname=LawyerProfile&SessionID=${ URLsid }`);
        //     const data = await res.text();  
        //     if (data) {
        //         if (data.indexOf('SetSystemDataDefault="1"') !== -1) {
        //             dispatch(setProfilePreferences(1));
        //         } else {
        //             dispatch(setProfilePreferences(0));
        //         }
        //     }
        // }
                
        // fetchProfileData();
        
        if (checkPurfileEdit(page)) {
            let DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
            if (DataReaderObj && (DataReaderObj as any).livedataRoot && page.params.id === DataReaderObj.getAppId()) {
                // entering a file & the livedataRoot is ready

                const checkFileLockStatus = () => {
                    BGTask.CheckFileLockStatus(
                        SESSION_INFO.appProvinceShort,
                        SESSION_INFO.firm.id,
                        page.params?.id,
                        SESSION_INFO.sid,
                        (newLockStatus: FileLock) => {
                            if (newLockStatus.status !== fileLockIndicatorRef.current?.status) {
                                updateFileLockIndicator(newLockStatus);
                            }
                        }
                    );
                };

                if (!FileCheckList.OneTimeCheck) {
                    FileCheckList.OneTimeCheck = true;
                    InFile.OneTimeCheck(
                        SESSION_INFO.appProvinceShort,
                        SESSION_INFO.firm.id,
                        page.params.id,
                        SESSION_INFO.sid,
                        livedataRootContainer.dataRoot
                    );
                    checkFileLockStatus();
                    if (!FileCheckList.LockStatusInterval){
                        FileCheckList.LockStatusInterval = setInterval(() => {
                            checkFileLockStatus()
                        }, 30000);
                    }
                }

                if (!FileCheckList.BGTaskCheck) {
                    FileCheckList.BGTaskCheck = true;
                    BGTask.CheckWholeFile(
                        SESSION_INFO.appProvinceShort,
                        SESSION_INFO.firm.id,
                        page.params.id,
                        SESSION_INFO.sid,
                        livedataRootContainer.dataRoot,
                        lddActivityCenterAdd
                    );
                }                
            }
        }
    }, [page, livedataRootContainer])  // when entering a file & livedataRoot is ready

    // Sync document-open user preferences to iframe so legacy compat uses window.realti_docPref only
    const openDocumentsAutomatically = useAppSelector((g: lddStateObject) => g.UserPreferences?.openDocumentsAutomatically ?? true);
    const suppressOpenDocNotice = useAppSelector((g: lddStateObject) => g.UserPreferences?.suppressOpenDocNotice ?? false);
    useEffect(() => {
        if (!checkPurfileEdit(page)) return;
        const tabName = page.controller?.tabName;
        if (tabName !== "Documents" && tabName !== "Client Portal") return;
        try {
            const iFrameWindow = getCurrentContentWindow();
            if (iFrameWindow && tabName === "Documents") {
                iFrameWindow.postMessage({
                    type: "REALTI_SYNC_DOC_PREFERENCE",
                    openDocumentsAutomatically,
                    suppressOpenDocNotice,
                }, "*");
            } else if (iFrameWindow && tabName === "Client Portal") {
                iFrameWindow.postMessage({
                    type: "REALTI_SYNC_DOC_PREFERENCE",
                    openDocumentsAutomatically: false,
                    suppressOpenDocNotice: true,
                }, "*");
            }
        } catch (e) { /* ignore */ }
    }, [page.params?.id, page.controller?.tabName, openDocumentsAutomatically, suppressOpenDocNotice]);

    const checkMustChangePassword = async () => {
        try {
            const response = await fetch(
                `/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${SESSION_INFO.firm.id}/uv/get/user?SessionID=${SESSION_INFO.sid}&id=${SESSION_INFO.user.id}`
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.ok && (data.result['MustChange'] === 1 || data.result['MustChange'] === '1')) {
                setShowPasswordModal(true);
            }
        } catch (error) {
            console.error('Error checking mustChange:', error);
        }
    };

    useEffect(() => {
        if (DisplayToastMessage) {
            const { message, status } = DisplayToastMessage;
            displayToastMsg({id: Date.now(), msg: message, type: status}, null);
            dispatch(clearDisplayToastMessage());
        }
    }, [DisplayToastMessage, dispatch]);

    useEffect(() => {
        if (SESSION_INFO) {
            checkMustChangePassword();
        }
    }, [SESSION_INFO]);

    return (
        <>
            <ActivityCenterContext.Provider value={
                {
                    Add: lddActivityCenterAdd,
                    Delete: lddActivityCenterDelete,
                    ClearWhenOut: lddActivityCenterClearWhenOut
                }
            }>
                <NavigationContext.Provider value={changeFrame}>
                    <RenewSessionPopup URLsid={URLsid} info={SESSION_INFO} page={page} />
                    <PaymentReminderPopup info={SESSION_INFO} page={page} navigationInFile={navigationInFile} />
                    {SESSION_INFO &&
                        <>
                            <TopBar />
                        <Modal size="xl" centered show={showModal > ""} onHide={() => setShowModal("")}>
                            {/* <Modal.Header className="d-flex justify-content-between align-items-center">
                                <span>Inbox</span>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    aria-label="Close" 
                                    onClick={() => setShowModal("")}
                                ></button>
                            </Modal.Header> */}
                            <Modal.Body className="p-0" style={{overflow: "hidden"}}>
                                {GetReactModalFrame({reactModalFrame: showModal})}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button 
                                    variant="btn-text"
                                    aria-label="Close" 
                                    onClick={() => setShowModal("")}
                                >Close</Button>
                            </Modal.Footer>
                        </Modal>
                            <main className="main-container" id="main-content">
                                <div className="main-container-inner">
                                <NavFileContainer
                                    page={page}
                                    drawerState={drawerState}
                                    setDrawerState={handleLeftDrawerClick}
                                />
                                    <LenderCentre />
                                    <ChequeInit />
                                    <EditChequeDetails />
                                    <UserContactListModal/>
                                    <EditFileNumberWarning />
                                    <APSNewFile />
                                    <MainPage
                                        info={SESSION_INFO}
                                        page={page}
                                        dataroot={livedataRootContainer.dataRoot}
                                        iframeProp={iframeProp}
                                        mainComponent={GetMainComponent()}
                                        fileLock={fileLockIndicator}
                                        reactFileComponent={GetReactFrame()} 
                                    />
                                    <MarketingCheck.MarketingPopup
                                        info={SESSION_INFO}
                                        page={page}
                                        dataRootContainer={livedataRootContainer}
                                    />
                                </div>
                                <RightSideContext.Provider value={{
                                    rightSideBoolean: rightBarVisible,
                                    rightSideShow: rightDrawer,
                                    account: SESSION_INFO?.user?.account,
                                }}>
                                    <NavFileContainerRightSide
                                        page={page}
                                        sidebarshow={rightDrawer}
                                        datarootContainer={livedataRootContainer}
                                        sidebar='right'
                                        toggle={handleRightDrawerToggle}
                                        toggleState={rightBarVisible}
                                        sid={URLsid}
                                        changeNoteDropdown={changeNoteDropdown}
                                        setChangeNoteDropdown={setChangeNoteDropdown}
                                    />
                                </RightSideContext.Provider>
                            </main>
                            
                            <ToastMessaging />
                        </>
                    }
                </NavigationContext.Provider>
            </ActivityCenterContext.Provider >
            <UpdatePasswordModal 
                show={showPasswordModal} 
                onHide={() => setShowPasswordModal(false)}
            />
        </>
    );
};
export default Home;
/**
 * This function checks all secondary iframe effects that need to be processed
 * after launching and setting the correct screen in the iframe.
 * @param navObj Describes next screen and what effects need to be set on that screen
 */
function checkNavigationSecondaryEffects(navObj: NavObjectType, dispatch: Dispatch<AnyAction>, sessionInfo?: lddGlobalSessionInfo) {
    // make sure close currentFrame's InframeComponent
    if (!CloseInframeComponent()) {
        return;
    }
    // Run generic iframe functions
    window.setTimeout(() => {
        if (navObj?.controller?.tabName === "Documents") {
            // we want to cache users documents opening default
            if (navObj.controller?.autoClick?.indexOf("documentListGroupingMethod") === 0 || navObj.controller?.screenAction === ScreenActions.openCloudDrive) {
                var storageObj = window.localStorage;
                storageObj.setItem("lddDocumentsDefault", JSON.stringify({ label: navObj.label, controller: navObj.controller }));
            }
        }

        if (navObj.action > "") {
            let param = navObj.actionParam;
            switch (typeof param) {
                case "number":
                case "string":
                    break;
                case "object":
                    if (Array.isArray(param) && param.length > 0) {
                        param = null;
                    }
                    break;
                default:
                    param = null;
            }
            runInnerFunction(navObj.action, param);
            // Click on specific ID element inside iframe
        } else if (navObj.controller?.autoClick && navObj.controller.autoClick.length > 0) {
            let iFrameWindow: Window = getCurrentContentWindow();
            const element = iFrameWindow.document.getElementById(navObj.controller.autoClick);
            if (!element) {
                console.log(`${navObj.controller.autoClick} doesn't exist in the current navObj`)
            } else {
                element.click();
            }
        } else if (navObj.controller?.screenAction) {
            const stateStore = store.getState();
            const livedataRoot = stateStore?.currentNavigation?.livedataRootContainer?.dataRoot;
            const dataProcessor: RPWDataReader = getDataReader(livedataRoot);
            const iFrameWindow: Window = getCurrentContentWindow();
            const controller = new ScreenController(iFrameWindow);
            switch (navObj.controller.screenAction) {
                case ScreenActions.setVTB:
                    dataProcessor.setVTB()
                    break;
                case ScreenActions.setTransferEstate:
                    const personStateEstate = controller.getNewScreen();
                    dataProcessor.setEstate(personStateEstate.tabName, personStateEstate.tabNumber)
                    break;
                case ScreenActions.setTransferCorporation:
                    const personStateCorp = controller.getNewScreen();
                    dataProcessor.setCorporation(personStateCorp.tabName, personStateCorp.tabNumber)
                    break;
                case ScreenActions.setTransferIndividual:
                    const personStateIndiv = controller.getNewScreen();
                    dataProcessor.setIndividual(personStateIndiv.tabName, personStateIndiv.tabNumber)
                    break;
                case ScreenActions.setMortgageInbox:
                    runInnerFunction("ReactShell.inFileImportMortgage", null);
                    break;
                case ScreenActions.openCloudDrive:
                    runInnerFunction("ldd_openCloudDrive", null);
                    break;
                case ScreenActions.openModalDialogue:
                    let iFrameWindow = getCurrentContentWindow();
                    iFrameWindow.liveformPopupDataNode = iFrameWindow.livedataRoot;
                    iFrameWindow.showModalDialog(`lfpopup.asp?NoHeader=1&SessionID=${sessionInfo.sid}&formasp=OREADocuments`,iFrameWindow, 'dialogHeight=700px;dialogWidth=1040px');
                    break;
                case ScreenActions.setOtherPartyType:
                    const otherParty = controller.getNewScreen();
                    dataProcessor.setOtherPartyType(otherParty.tabNumber, navObj.controller.onClickDispatchPayload.value);
                    break;
                default:
                    break;
            }
        } else if (navObj.controller?.autoClickClassName && navObj.controller?.autoClickClassNamePosition > -1) {
            let iFrameWindow: Window = getCurrentContentWindow();
            const elements = iFrameWindow.document.querySelectorAll(navObj.controller?.autoClickClassName);
            if (!elements[navObj.controller?.autoClickClassNamePosition]) {
                console.log(`${navObj.controller?.autoClickClassName} doesn't exist in the current navObj`)
            } else {
                (elements[navObj.controller?.autoClickClassNamePosition] as HTMLElement).click();
            }
        }
    }, 100)
    // turn on popups i.e. fire insurer, 
    if (navObj.controller?.onClickDispatch) {
        ThirdPartyDispatch(dispatch, navObj.controller.onClickDispatch, true, navObj.controller.onClickDispatchPayload || {});
    }
    // react only components 
}


/**
 * @deprecated This usage of this function should be replaced by using the NavigationContext
 * 
 * const changeURL = useContext(NavigationContext);
 * 
 * onClick = {() => changeURL(navItem);}
 *  
 * @param history window.history
 * @param location window.location
 * @param navItem Describes the next page to navigate to
 */
export function changeURL(history, location, navItem: NavObjectType) {
    const state: lddStateObject = store.getState();
    const searchParams = new URLSearchParams(location.search);
    const sid = state.SessionID;
    // Is there a way to check JSON parse types?
    const params: NavObjectType = JSON.parse(searchParams.get("params"));
    if (navItem.component !== "main" && params.component === "main") {
        // Close all frame tabs when moving to new component
        if (!closeAll()) {
            return;
        }
    }
    history.push("compatshell.html?SessionID=" + sid + "&params=" + encodeURIComponent(JSON.stringify(navItem)));
    navigateNewPage(navItem, sid);
}


function purfileNavStripPopups(navObj: NavObjectType): NavObjectType {
    if (navObj.component !== "main" && navObj.params?.formasp !== "purfileedit") {
        return navObj;
    }
    let newController = undefined
    if (navObj.controller) {
        newController = {
            tabName: navObj.controller.tabName,
            tabNumber: navObj.controller.tabNumber,
        }
    }
    const newNav = newController ? {
        ...navObj,
        controller: newController,
    } : { ...navObj }
    delete newNav.action
    delete newNav.actionParam
    delete newNav.callback
    delete newNav.redirect
    delete newNav.init;
    return newNav
}

function navigationInFile(navObj: NavObjectType): boolean {
    return (((navObj.params === undefined && navObj.url === undefined) || navObj.params?.formasp === "purfileedit")
        && (navObj.component === "main" || navObj.reactFrame === 'CLIENTPORTAL'));
}